import '../css/style.scss'

const $ = jQuery

$(document).ready(function () {
  // initLightSlider()
  initAppearElement()
    initMasonry()
  initFilter() 
    initSort()
    // initPopup_in_query()
    inittouchTouch()
})
window.onload = function () {
  if (window.innerWidth < 993) {
    init_openMenu()
  }
}

// ############functie voor uitklapmenu########
function init_openMenu() {
  $('#button_nav').click(function () {
    $('#button_nav').toggleClass('open-menu')
    $('#menu_nav').toggleClass('open-menu')
  })
}
function initLightSlider() {
  jQuery('.lightslider').lightSlider({
    item: 1,
    loop: true,
    auto: false,
    pauseOnHover: true,
    slideMove: 1,
    easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
    speed: 1500,
    pause: 10000,
    controls: true,
    pager: false,
    adaptiveHeight: true,
  })
}
function initAppearElement() {
  // Function to check if the element is in the viewport
  function isInViewport(element) {
    var rect = element.getBoundingClientRect()
    return rect.top < window.innerHeight && rect.bottom >= 0
  }

  // Function to get the transform value based on direction
  function getTransform(direction, isIn) {
    var distance = 200 // Adjust this value as needed
    switch (direction) {
      case 'left':
        return isIn
          ? 'translateX(-' + distance + 'px)'
          : 'translateX(' + distance + 'px)'
      case 'right':
        return isIn
          ? 'translateX(' + distance + 'px)'
          : 'translateX(-' + distance + 'px)'
      case 'top':
        return isIn
          ? 'translateY(-' + distance + 'px)'
          : 'translateY(' + distance + 'px)'
      case 'bottom':
        return isIn
          ? 'translateY(' + distance + 'px)'
          : 'translateY(-' + distance + 'px)'
      default:
        return ''
    }
  }

  // Initialize and animate elements
  $("[class*='appear-']").each(function () {
    var $this = $(this)
    var classInfo = $this
      .attr('class')
      .match(/appear-(left|right|top|bottom)-(\d+)/)
    if (classInfo) {
      var direction = classInfo[1]
      var delay = parseInt(classInfo[2], 10)

      // Set initial styles
      $this.css({
        opacity: '0',
        transform: getTransform(direction, true),
        transition: 'all 0.5s ease',
      })

      // Animate if already in viewport
      if (isInViewport(this)) {
        setTimeout(function () {
          $this.css({
            opacity: '1',
            transform: 'translateX(0) translateY(0)',
          })
        }, delay)
      }
    }
  })

  // Animate elements on scroll
  $(window).on('scroll', function () {
    $("[class*='appear-']").each(function () {
      var $this = $(this)
      var classInfo = $this
        .attr('class')
        .match(/appear-(left|right|top|bottom)-(\d+)/)
      if (classInfo) {
        var direction = classInfo[1]
        var delay = parseInt(classInfo[2], 10)

        if (isInViewport(this)) {
          // Animate into view
          setTimeout(function () {
            $this.css({
              opacity: '1',
              transform: 'translateX(0) translateY(0)',
            })
          }, delay)
        } else {
          // Animate out of view
          $this.css({
            opacity: '0',
            transform: getTransform(direction, false),
          })
        }
      }
    })
  })
}
function initFilter() {
  //
  // dropdown open:
   $('.dropdown-item').click(function () {
     // Toggle visibility
     $('.checkboxes-container').toggle();
     $('.dropdown-item').toggleClass('open');
   })
  // Filterfunctie
  function filterItems() {
    const selectedCategories = $('input[name="categorie"]:checked')
      .map(function () {
        return this.value
      })
      .get()

    $('.query-filter__item-list').each(function () {
      const itemCategories = $(this).data('title').split(' ')
      const isVisible =
        selectedCategories.length === 0 ||
        selectedCategories.some((category) => itemCategories.includes(category))
      $(this).toggle(isVisible)
    })

    // Update masonry layout
    $('.masonry').masonry('layout')
  }

  // Roep filterItems aan wanneer checkboxes veranderen
  $('input[name="categorie"]').change(filterItems)

  // Eerste filtering uitvoeren bij initialisatie
  filterItems()
}

function initSort() {
  function sortItems() {
    const sortOption = $('#sortingOptions').val()
    const itemsContainer = $('.query-filter__wrapper')
    let items = $('.itemList').get()

    items.sort(function (a, b) {
      let dateA, dateB
      if (sortOption.includes('datum_artikel')) {
        dateA = $(a).data('publicatie-datum-timestamp')
        dateB = $(b).data('publicatie-datum-timestamp')
      } else {
        dateA = $(a).data('datum-evenement-timestamp')
        dateB = $(b).data('datum-evenement-timestamp')
      }

      return sortOption.includes('asc') ? dateA - dateB : dateB - dateA
    })

    // Voeg de gesorteerde items weer toe aan de container
    $.each(items, function (index, item) {
      itemsContainer.append(item) // Dit behoudt de elementen in de DOM maar verandert hun volgorde
    })

    $('.masonry').masonry('reloadItems').masonry('layout') // Herlaad de items in Masonry en update de layout
  }

  // Roep sortItems aan wanneer de sorteer optie verandert
  $('#sortingOptions').change(sortItems)

  // Sorteer meteen bij het laden van de pagina, als dat gewenst is
  $(document).ready(function () {
    // sortItems()
  })
}

function initMasonry() {

  //check if .masonry is present on the page:
  if ($('.masonry').length) {
    // If so, add the masonry to the page:
    var $masonry_grid = $('.masonry').masonry({
      itemSelector: '.masonry__item',
      // gutter: 10,
      // columnWidth: '50%',
      percentPosition: true,
      // horizontalOrder: true,
    })
    // layout Masonry after each image loads
    $masonry_grid.imagesLoaded().progress(function () {
      $masonry_grid.masonry('layout')
    })
  }
}
function inittouchTouch() {
  if (document.getElementById('gallery')) {
    // Initialize touchTouch plugin for elements with the class 'item' inside #gallery
    touchTouch(document.querySelectorAll('#gallery .item'), {
      // options here
    })
  }
}